/* Product page add-ons (loaded deferred, product pages only).
   1. Subscribe option: show the regular price struck through.
   2. Complete your routine: small prev/next arrows below the carousel.
   3. Buy more, save more: volume tiers (snippets/volume-tiers.liquid).
   Each part watches only its own container, not the whole page. */
(function () {
  function watch(target, fn) {
    var queued = false;
    var run = function () { queued = false; fn(); };
    var obs = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(run, 50);
    });
    obs.observe(target, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    fn();
    return obs;
  }

  /* 1. Struck-through regular price on the subscribe option */
  function comparePrice(block) {
    var one = block.querySelector('.onetime-radio .price-label');
    var sub = block.querySelector('.subscription-radio .price-label');
    if (!one || !sub) return;
    var regular = one.textContent.trim();
    var compare = sub.parentNode.querySelector('.rc-compare-price');
    if (!regular || regular === sub.textContent.trim()) {
      if (compare) compare.parentNode.removeChild(compare);
      return;
    }
    if (!compare) {
      compare = document.createElement('s');
      compare.className = 'rc-compare-price';
      sub.parentNode.insertBefore(compare, sub);
    }
    if (compare.textContent !== regular) {
      compare.textContent = regular;
      compare.setAttribute('aria-label', 'Regular price ' + regular);
    }
  }

  /* 2. Arrows below the Complete your routine carousel */
  var ICON = {
    next: '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M5 2l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    prev: '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M9 2L4 7l5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };
  function button(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pr-arrow pr-arrow--' + dir;
    b.setAttribute('aria-label', dir === 'next' ? 'Scroll to next product' : 'Scroll to previous product');
    b.innerHTML = ICON[dir];
    return b;
  }
  function arrows(box) {
    var el = box.querySelector('.product-recommendations__body.swiper-initialized');
    if (!el || !el.swiper || el.getAttribute('data-pr-arrows')) return false;
    var swiper = el.swiper;
    el.setAttribute('data-pr-arrows', '1');
    var row = document.createElement('div');
    row.className = 'pr-arrows';
    var prev = button('prev');
    var next = button('next');
    row.appendChild(prev);
    row.appendChild(next);
    el.parentNode.insertBefore(row, el.nextSibling);
    prev.addEventListener('click', function (e) { e.preventDefault(); swiper.slidePrev(); });
    next.addEventListener('click', function (e) { e.preventDefault(); swiper.slideNext(); });
    function refresh() {
      row.hidden = swiper.isLocked || swiper.slides.length < 2;
      prev.disabled = swiper.isBeginning;
      next.disabled = swiper.isEnd;
    }
    swiper.on('slideChange reachBeginning reachEnd fromEdge resize update lock unlock', refresh);
    refresh();
    return true;
  }

  function start() {
    var blocks = document.querySelectorAll('.recharge-subscription-widget');
    for (var i = 0; i < blocks.length; i++) {
      (function (block) { watch(block, function () { comparePrice(block); }); })(blocks[i]);
    }
    var boxes = document.querySelectorAll('.product__complementaries');
    for (var j = 0; j < boxes.length; j++) {
      (function (box) {
        var done = false;
        var obs = watch(box, function () {
          if (arrows(box)) { done = true; if (obs) obs.disconnect(); }
        });
        if (done) obs.disconnect();
      })(boxes[j]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Buy more, save more: volume tiers set the quantity, follow the quantity box and size changes */
(function () {
  function money(cents, fmt) {
    var n = (cents / 100).toFixed(2);
    var withCommas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    fmt = fmt || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }
  function init(box) {
    var section = box.closest('.shopify-section') || document;
    var qty = section.querySelector('input.quantity__input[name="quantity"]');
    var opts = box.querySelectorAll('.vt__opt');
    var prices = {};
    try { prices = JSON.parse(box.getAttribute('data-prices')); } catch (e) {}
    var fmt = box.getAttribute('data-money');
    var note = box.querySelector('[data-sub-note]');

    function highlight() {
      var v = qty ? parseInt(qty.value, 10) || 1 : 1;
      var best = null;
      for (var i = 0; i < opts.length; i++) {
        if (v >= parseInt(opts[i].getAttribute('data-qty'), 10)) best = opts[i];
      }
      for (var j = 0; j < opts.length; j++) {
        var on = opts[j] === best;
        opts[j].classList.toggle('is-active', on);
        opts[j].querySelector('input').checked = on;
      }
    }
    function setQty(n) {
      if (!qty) return;
      qty.value = n;
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
      highlight();
    }
    function reprice() {
      var idInput = section.querySelector('form[action*="/cart/add"] input[name="id"]');
      var price = idInput && prices[idInput.value];
      if (price == null) return;
      for (var i = 0; i < opts.length; i++) {
        var pct = parseInt(opts[i].getAttribute('data-pct'), 10);
        opts[i].querySelector('[data-was]').textContent = money(price, fmt);
        opts[i].querySelector('[data-now]').textContent = money(Math.floor(price * (100 - pct) / 100), fmt);
      }
    }
    function subState() {
      var sel = section.querySelector('input[name="purchaseOption"]:checked');
      var isSub = !!sel && sel.value === 'subscription';
      box.classList.toggle('is-sub', isSub);
      if (note) note.hidden = !isSub;
    }

    for (var i = 0; i < opts.length; i++) {
      opts[i].addEventListener('click', function (e) {
        e.preventDefault();
        var q = parseInt(this.getAttribute('data-qty'), 10);
        setQty(this.classList.contains('is-active') ? 1 : q);
      });
    }
    if (qty) {
      qty.addEventListener('change', highlight);
      qty.addEventListener('input', highlight);
    }
    section.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.quantity__button')) setTimeout(highlight, 0);
    });
    section.addEventListener('change', function (e) {
      if (e.target.name === 'purchaseOption') subState();
      else setTimeout(reprice, 60);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(reprice, 0); });
    }
    highlight();
    subState();
  }
  function start() {
    var boxes = document.querySelectorAll('[data-volume-tiers]');
    for (var i = 0; i < boxes.length; i++) init(boxes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
